export default __webpack_public_path__ + "static/media/neuro.ee457c91.svg";